import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

const Layout = ({ lang, children }) => {
  React.useEffect(() => {
    document.documentElement.lang = lang === "mx" ? "es-MX" : "en";
  }, [lang]);
  return (
    <I18nProvider lang={lang}>
      <Header />
      {children}
      <Footer />
      <CookieBanner />
    </I18nProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/mx" replace />} />

          <Route path="/thank_you" element={<Layout lang="mx"><ThankYou /></Layout>} />

          <Route path="/mx" element={<Layout lang="mx"><Home /></Layout>} />
          <Route path="/mx/privacidad" element={<Layout lang="mx"><LegalPage pageKey="privacy" /></Layout>} />
          <Route path="/mx/cookies" element={<Layout lang="mx"><LegalPage pageKey="cookies" /></Layout>} />
          <Route path="/mx/terminos" element={<Layout lang="mx"><LegalPage pageKey="terms" /></Layout>} />

          <Route path="/en" element={<Layout lang="en"><Home /></Layout>} />
          <Route path="/en/privacy" element={<Layout lang="en"><LegalPage pageKey="privacy" /></Layout>} />
          <Route path="/en/cookies" element={<Layout lang="en"><LegalPage pageKey="cookies" /></Layout>} />
          <Route path="/en/terms" element={<Layout lang="en"><LegalPage pageKey="terms" /></Layout>} />

          <Route path="*" element={<Navigate to="/mx" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
